<template>
  <div class="p-autocomplete-wrap">
    <AutoComplete
        required
        v-model="carNumIpt"
        :suggestions="fetchedCarNumList"
        @complete="changeCarNum"
        @item-select="handleCarNumSelect"
        dropdown
        emptySearchMessage="검색 결과가 없습니다."
        placeholder="차량번호"
    />
  </div>
</template>

<script setup>
import {defineExpose, defineProps, ref} from "vue";
import axios from "@/composables/Axios";
import _ from "lodash";
import {useStore} from "vuex";
import tachoEntity from "@/entity/TachoEntity";
import Entity from "@/entity/OperationEntity";

const store = useStore();
const url = tachoEntity.baseUrl;
const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
const headers = entity.get();
const emit = defineEmits(['change']);
const props = defineProps({
  initialCarNum: String,
});

const carNumIpt = ref(props.initialCarNum || '');
const fetchedCarNumList = ref([]);

async function searchCarNum() {
  if (carNumIpt.value.length < 2) {
    fetchedCarNumList.value = [];
    return;
  }

  const params = {
    query: carNumIpt.value.toLowerCase(),
    carType: '22',
  };
  try {
    const resp = await axios.$get(`${url}car-info/search/list?page=0&size=10`, {params}, headers);
    fetchedCarNumList.value = _.get(resp, 'data.data.content', []);
  } catch (e) {
    store.commit("openMessageBox", e);
  }
}

function changeCarNum() {
  emit('change', carNumIpt.value);
  debouncedSearchCarNum();
}

function handleCarNumSelect({value}) {
  emit('change', value);
}

const debouncedSearchCarNum = _.debounce(searchCarNum, 500);

function cleanValue() {
  carNumIpt.value = '';
}

defineExpose({
  cleanValue,
});
</script>

<style>
</style>
